import React from 'react';
import {
  Alert, Button, Col, Modal,
} from 'react-bootstrap';
import { DropZone } from './DropZone/DropZone';
import { InstructionDropZoneAudio } from './InstructionDropZone/InstructionDropZoneAudio';
import { FileToUpload, LibraryType, UploadFilesModalStatus } from './types';
import { UploadFilesList } from './UploadFilesList/UploadFilesList';
import classNames from './UploadFilesModal.module.scss';
import { useUploadFilesAudio } from './useUploadFilesAudio';

export interface UploadFilesModalAudioProps {
  title?: string;
  onUploaded?: (files: FileToUpload[]) => void;
  onClose?: () => void;
}

const audioAccept = {
  'audio/mpeg': ['.mp3'],
  'audio/wav': ['.wav'],
  'audio/x-wav': ['.wav'],
};

export function UploadFilesModalAudio(props: UploadFilesModalAudioProps) {
  const {
    title = 'Bulk Upload Audio',
    onUploaded,
    onClose,
  } = props;

  const {
    isLoading,
    filesToUpload,
    handleDropZoneChange,
    manageListCallbacks,
    handleUploadClick,
    isUploadFinished,
    errorMessage,
    updateAudioType,
    hasFilesWithoutType,
    hasErrorStatus,
  } = useUploadFilesAudio(onUploaded);

  const handleCloseClick = () => {
    if (isUploadFinished) {
      manageListCallbacks.onUploadFinished(filesToUpload);
    } else {
      onClose?.();
    }
  };

  const isUploadButtonDisabled = isLoading
      || hasErrorStatus
      || hasFilesWithoutType
      || !filesToUpload.length
      || isUploadFinished
      || !!errorMessage;

  return (
    <div className={classNames.container}>
      <Modal
        show
        centered
        scrollable
        contentClassName={classNames.modalContent}
        dialogClassName={classNames.modalBackgroundDialog}
      >
        <Modal.Header className={classNames.modalHeader}>
          <Modal.Title className={classNames.modalTitle}>
            <Col className="text-left">
              {title}
            </Col>
          </Modal.Title>
          {errorMessage && (
          <Alert variant="danger">{errorMessage}</Alert>
          )}
          {hasFilesWithoutType && !errorMessage && (
          <Alert variant="warning">Please select audio type (music/effect) for all files</Alert>
          )}
        </Modal.Header>
        <Modal.Body className={classNames.modalBody}>
          {filesToUpload.length
            ? (
              <UploadFilesList
                libraryType={LibraryType.Audio}
                filesToUpload={filesToUpload}
                manageListCallbacks={manageListCallbacks}
                onAudioTypeChange={updateAudioType}
                isLoading={isLoading}
                isUploadFinished={isUploadFinished}
              />
            )
            : (
              <DropZone
                disabled={!!filesToUpload.length}
                accept={audioAccept}
                onChange={(files) => handleDropZoneChange(files)}
                InstructionComponent={InstructionDropZoneAudio}
              />
            )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={isLoading}
            variant="secondary"
            onClick={handleCloseClick}
          >
            Close
          </Button>
          <Button
            disabled={isUploadButtonDisabled}
            variant="primary"
            onClick={handleUploadClick}
          >
            Upload
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
